import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";
import { isSuperAdminUser } from "@/helper/systemIds";

export const companyEntityAdapter: EntityAdapter = {
  entity: "company",
  adjustCreatePayload: (_result, values) => ({
    ...values,
    team_id: values.team,
    parent: values.parent === undefined || values.parent.length === 0 ? null : values.parent,
    main_building: {
      name: values.building_name,
      zip: values.zip,
      street_house: values.street_house,
      city: values.city,
      contact_name: values.contact_name,
      contact_email: values.contact_email,
      contact_phone: values.contact_phone,
    },
  }),
  adjustUpdatePayload: (_result, values) => ({
    ...values,
    parent:
      values.parent === undefined || values.parent === null || values.parent.length === 0
        ? null
        : values.parent,
    team_id: values.team,
  }),
  defaultSort: { sort: "name", tableSort: "name", descending: false },
  bodyCellSx: (company, baseSx) =>
    company.is_active === false ? { ...baseSx, color: "lightgray" } : baseSx,
  deletesPermanently: (userEmail) => isSuperAdminUser(userEmail),
  toolbar: { rowSelectionElementsPosition: "besideCustomAction" },
};
